import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  getUserDetailsById,
  getMyTeam,
  getImgSociety
} from '../../../../utils/apiUser';

import Profile from '../../Employee/Profile';

import Loading from '../../../core/Loading';

const WidgetProfile = props => {
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const [userTeam, setUserTeam] = useState(null);
  const [imgSociety, setImgSociety] = useState(null);

  const getFormattedData = data =>
    data
      ? data.map(item => {
          if (item.name) {
            return {
              ...item,
              id: `${item.name}${item.certification}`,
              expanded: true
            };
          }
          return {
            ...item,
            id: `${item.title}${item.companyName}`,
            expanded: true
          };
        })
      : [];
  const getFormattedContactData = (userDetail, userProfile) => ({
    ...userProfile,
    extension: userProfile.extension,
    telephone: userProfile.phones,
    mobile: '000 00 00 00',
    address: userProfile.address,
    email: userProfile.email,
    name: userProfile.name,
    lastname: userProfile.lastname,
    publicName: userProfile.publicName,
    ...userDetail.rrss
  });

  const getImageSociety = idUser => {
    Promise.resolve(getImgSociety(idUser)).then(res => {
      const imgSociety =
        process.env.NODE_ENV === 'production'
          ? `https://intranetapi.atresmedia.com/images${res}`
          : `https://intranetpre.atresmedia.com/images${res}`;
      setImgSociety(imgSociety);
    });
  };

  const getData = id => {
    const { idUser } = props;
    getUserDetailsById(id || idUser)
      .then(userDetails => {
        const { userDetail, userProfile } = userDetails;
        setUserData({
          ...userDetail,
          userContact: getFormattedContactData(userDetail, userProfile),
          languages: getFormattedData(userDetail.languages),
          educations: getFormattedData(userDetail.educations),
          currentPositions: getFormattedData(userDetail.currentPositions),
          imgSociety: getImageSociety(idUser),
          pastPositions: getFormattedData(userDetail.pastPositions)
        });

        getMyTeam(userProfile.idDepartment)
          .then(team => {
            setUserTeam(
              team.map(partner => ({
                userId: partner.userId,
                person: `${partner.name} ${partner.lastname}`,
                lastname: partner.lastname,
                job: partner.profile,
                image: partner.pathImage,
                email: partner.email,
                avatarPhoto: partner.avatarPhoto
                  ? partner.avatarPhoto
                  : undefined
              }))
            );
          })
          .catch(error => {
            throw error;
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(error => {
        throw error;
      });
  };

  useEffect(() => {
    const { idUser } = props;
    document.body.style.overflow = 'unset';
    getData(idUser);
  }, []);

  const getProfile = () => {
    const { idUser } = props;
    const {
      userContact,
      rrss,
      description,
      languages,
      educations,
      hobbies
    } = userData;

    const getHtmlParsed = data => ({ __html: data });
    return (
      <Fragment>
        <Profile
          isWidget
          idUser={idUser}
          dataLanguage={languages}
          dataHobbies={hobbies}
          dataTeam={userTeam}
          dataEducations={educations}
          dataUser={userContact}
          dataSocial={rrss}
          imgSociety={imgSociety}
          educationsPublic={userData.educationsPublic}
          languagesPublic={userData.languagesPublic}
          hobbiesPublic={userData.hobbiesPublic}
        >
          {(description && description.length) === 11 ? (
            undefined
          ) : (
            // eslint-disable-next-line react/no-danger
            <p dangerouslySetInnerHTML={getHtmlParsed(description)} />
          )}
        </Profile>
      </Fragment>
    );
  };

  return loading ? <Loading size="xl" /> : getProfile();
};

WidgetProfile.propTypes = {
  userDetail: PropTypes.shape({
    description: PropTypes.string,
    educations: PropTypes.arrayOf(
      PropTypes.shape({
        degree: PropTypes.string,
        endDate: PropTypes.string,
        schoolName: PropTypes.string,
        startDate: PropTypes.string
      })
    ),
    languages: PropTypes.arrayOf(
      PropTypes.shape({
        certification: PropTypes.string,
        name: PropTypes.string,
        proficiency: PropTypes.string
      })
    ),
    lastModifiedDate: PropTypes.string,
    rrss: PropTypes.shape({
      facebook: PropTypes.string,
      twitter: PropTypes.string,
      linkedin: PropTypes.string,
      instagram: PropTypes.string,
      vimeo: PropTypes.string
    }),
    position: PropTypes.arrayOf(
      PropTypes.shape({
        companyName: PropTypes.string,
        current: PropTypes.bool,
        endDate: PropTypes.string,
        startDate: PropTypes.string,
        summary: PropTypes.string,
        title: PropTypes.string
      })
    )
  }),
  userProfile: PropTypes.shape({
    address: PropTypes.string,
    extension: PropTypes.number,
    email: PropTypes.string,
    employeeId: PropTypes.string,
    idDepartment: PropTypes.number,
    idSubDepartment: PropTypes.number,
    lastname: PropTypes.string,
    location: PropTypes.string,
    name: PropTypes.string,
    profile: PropTypes.string,
    societyId: PropTypes.string,
    typology: PropTypes.string,
    userId: PropTypes.number,
    username: PropTypes.string
  })
};

const mapStateToProps = ({ user }) => ({
  username: user.user.username,
  idUser: user.user.userId
});

export default connect(mapStateToProps, null)(WidgetProfile);
